export default {
  forward: 'Forward',
} as const;
